<template>
  <ClientOnly>
    <GfrButton v-show="backTopShow" ref="backTopRef" :class="['app-back-top']" @click="backToTop">
      <svg width="100%" height="100%" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="23" cy="23" r="23" fill="#D9D9D9" fill-opacity="0.1" />
        <path d="M23 14L31 21.7143L29.6667 23L23 16.5714L16.3333 23L15 21.7143L23 14Z" fill="#D9D9D9" />
        <path d="M23 21L31 28.7143L29.6667 30L23 23.5714L16.3333 30L15 28.7143L23 21Z" fill="#D9D9D9" />
      </svg>
    </GfrButton>
  </ClientOnly>
</template>
<script lang="ts" setup>
const props = defineProps({
  scrollTrigger: Boolean, // 是否开启滚动触发, TODO: 未实现
  fixed: {
    type: Boolean,
    default: false
  } // 是否处于固定位置
})
const backTopRef = ref<any>(null)
const backTopShow = ref(false)
function backToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
function checkBackTopShow() {
  if (backTopRef.value) {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    backTopShow.value = scrollTop > window.innerHeight * 2
  }
}
onMounted(async () => {
  await nextTick()
  checkBackTopShow()
  window.addEventListener('scroll', checkBackTopShow)
})
onUnmounted(() => {
  window.removeEventListener('scroll', checkBackTopShow)
})
</script>
<style lang="scss" scoped>
.app-back-top {
  @apply block h-11.5 w-11.5 rounded-full border border-[#4F5258];
}
.app-back-top-fixed {
  @apply fixed bottom-4 right-4;
}
</style>
